import { fadeInAnimationRule } from '@repo/ui/animations';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled, { keyframes, css } from 'styled-components';

export const ElementWrapper = styled.div``;

export const MasonryColumn = styled.div<{
  minColumnWidth?: number;
  gap?: number;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${ElementWrapper} {
    margin-bottom: ${({ gap }) => gap}px;
  }

  min-width: min(${({ minColumnWidth }) => minColumnWidth}px, 100%);
  height: 100%;
`;

export const Wrapper = styled.div<{ gap?: number; height?: string }>`
  height: ${({ height }) => (height ? height : '100%')};
  width: 100%;
  display: flex;

  animation: ${fadeInAnimationRule};
  animation-duration: 1s;

  ${QUERIES.largeTabletAndUp} {
    padding-right: 0;
  }

  ${MasonryColumn} + ${MasonryColumn} {
    margin-left: ${({ gap }) => gap}px;
  }
`;

const shimmer = keyframes`
  from {
    background-position: -468px 0
  }
  to {
    background-position: 468px 0
  }
`;

const loadingState = css`
  animation: ${shimmer};
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

export const SkeletonWrapper = styled.div<{ isLoading: boolean }>`
  position: relative;
  aspect-ratio: 1;
  border-radius: ${themeStyle.radiusMedium};
  overflow: hidden;

  ${({ isLoading }) => {
    if (isLoading) {
      return loadingState;
    }
    return css`
      animation: none;
    `;
  }}
  background: linear-gradient(to right, #d1f6ef 5%, rgba(151, 209, 251, 0.5) 45%, #d1f6ef 90%);
  background-size: 1000px 100%;
  cursor: ${({ isLoading }) => (isLoading ? 'default' : 'pointer')};
`;
